































import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class Control extends Vue {
  @Prop() public isEdit!: boolean;
  @Prop() public title?: string;
  @Prop({ default: 36 }) public height: number;
  @Prop({ default: null }) public validator: Components.ControlValidator;
  @Prop({default:null}) public provider: Components.IDirectEditProvider;
  @Prop({default:null}) public editor: Vue;  
  @Prop({default:false}) public enabled: boolean;
  @Prop() public tooltip?: string;
  @Prop({default:false}) public isMultilineText: boolean;
  @Prop({default:false}) public required: boolean;
  @Prop({default:false}) public keyfield: boolean; 
  @Prop({default:true}) public isDirectEditEnabled: boolean;    
  // @Prop({default:false}) public adjustHeight: boolean;
  // //InValidの場合だけ高さを14px高くして表示する
  // public get adjustedHeight(){
  //   if (this.adjustHeight == false || (this.validator && this.validator.validateMessage)) return this.height;
  //   else return this.height - 6;
  // }
  target : HTMLElement;
  copyPopover: boolean = false;

  public get editButtonEnabled() : boolean {
    return this.enabled && this.provider != null && this.provider.hasDirectPerm();
  }
  public get editButtonVisible() :boolean {
    return this.provider != null &&  (this.provider as any).isDirectEditting == false;
  }
  public created(){
    this.translatedTitle = this.$translate(this.title);
  }
  public mounted() {
    if(this.tooltip) this.$nextTick(()=>{
      if (this.$refs.tooltip_target == null) return;//空の場合がある
      this.$api.tooltip.mount(this, this.$refs.tooltip_target as Element,this.tooltip);      
    });
  }

  public translatedTitle = '';
  public isDirectEdit :boolean = false;
  public isActive: boolean = false;
  private onDirectEdit(){
    //編集値のクローンが必要
    if (this.editButtonEnabled == false) return;
    // DirectEditが不可の項目の鉛筆をクリックしたら全体編集モードに移行する
    if (!this.isDirectEditEnabled) {
      if((this.editor as Components.Editor).owner.dialogMode) (this.editor as Components.Editor).owner.onEdit(false);
      else (this.editor as Components.Editor).owner.onOpenDialog();
      return;
    }
    this.$api.sckeys.filter = (key:string) =>key == "F9" || key == "F12";

    this.provider.onDirectEdit();
    this.isDirectEdit = true;
    document.body.addEventListener('click', this.onClickOtherElement, { capture: true });

    this.$nextTick(()=>{
      var focussableElements = 'a:not([disabled]), button:not([disabled]),select:not([disabled]), input[type=text]:not([disabled]), [tabindex]:not([disabled]):not([tabindex="-1"])';

      var focussable = (this.$refs.target as HTMLElement).querySelectorAll(focussableElements);
      if (focussable != null && focussable.length > 0) {
        const input = focussable[0] as HTMLElement;
        input.focus();
      }
    });

  }
  private onDirectCommit(){
    //バリデーションをパスしたらコミット=>クローズ
    if (this.validator.validate()){
      this.provider.onDirectCommit();
      this.isDirectEdit = false;
      document.body.removeEventListener('click', this.onClickOtherElement,{ capture: true });
      this.$api.sckeys.filter = null;
    }
  }
  private onDirectClose(){
     this.provider.onDirectClose();
     this.isDirectEdit = false;
     document.body.removeEventListener('click', this.onClickOtherElement,{ capture: true });
    this.$api.sckeys.filter = null;     
     this.validator.reset();
  }

  private onMouseOver(){
    this.isActive = true;
  }
  private onMouseOut(){
    this.isActive = false;
  }
  private onCopy(){
    var content = (this.$refs.copy_target as HTMLElement).innerText;
    (navigator as any).clipboard.writeText(content);

    this.target = this.$refs.copy_button as HTMLElement;
    this.copyPopover = true;    
  }
  public onClickOtherElement(e: any) {
      
      const modal = document.getElementById('builtinModal');
      const modal2 = document.getElementById('popupEditor');
      const modal3 = document.getElementById('workflowDialog');            
      if (modal != null && modal.contains(e.srcElement)) return;
      if (modal2 != null && modal2.contains(e.srcElement)) return;        
      if (modal3 != null && modal3.contains(e.srcElement)) return;
      

      // if (this.$el.contains(e.srcElement) == false && this.isDirectEdit && (e.srcElement.lastChild != null &&  e.srcElement.lastChild.id == 'spinner') == false) {
      if (this.$el.contains(e.srcElement) == false && (this.editor == null || this.editor.$el.querySelector('.cx_tabcontent').contains(e.srcElement) == false) && this.isDirectEdit) {       
        //this.onDirectClose();
        this.$api.modal.showDialog('確認メッセージ','編集中のデータは保存されていません。破棄してもよろしいですか?',false, '破棄する','戻る')
          .then(()=>{this.onDirectClose(); e.srcElement.click();}); //フォーカスは戻せない(focusinを使用すればできるかもしれない)

          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
      } 
    }
    public onPopuped(){
      console.log((this.$refs.popup as any)._toolpop.$tip.className);
      (this.$refs.popup as any)._toolpop.$tip.className += " copy_popover";
    }
}

